import "scheduler-polyfill";

const handleFullfilled = (value) => ({ status: "fullfilled", value });
const handleRejected = (reason) => ({ status: "rejected", reason });

if (!Promise.allSettled) {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map((p) =>
        Promise.resolve(p).then(handleFullfilled, handleRejected)
      )
    );
  };
}
